var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.5 13.5h17.797l-5.449 6.54a1.499 1.499 0 102.306 1.92l7.5-9c.058-.07.087-.153.13-.231.036-.063.08-.117.107-.186.067-.172.108-.354.108-.537L24 12l-.002-.006c0-.183-.04-.364-.108-.537-.027-.069-.07-.123-.106-.186-.043-.078-.072-.16-.13-.231l-7.5-9a1.503 1.503 0 00-2.114-.192 1.499 1.499 0 00-.192 2.112l5.45 6.54H1.5a1.5 1.5 0 000 3z"}));
}

ArrowRight.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
